import { render } from "./AchievementPopupsContainer.vue?vue&type=template&id=867717ba&scoped=true&ts=true"
import script from "./AchievementPopupsContainer.vue?vue&type=script&lang=ts"
export * from "./AchievementPopupsContainer.vue?vue&type=script&lang=ts"

import "./AchievementPopupsContainer.vue?vue&type=style&index=0&id=867717ba&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-867717ba"]])

export default __exports__